/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Feature_3Inputs */

const en_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early access to new features`)
};

const id_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses awal ke fitur baru`)
};

const ms_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses awal kepada ciri baru`)
};

const ca_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accés anticipat a noves funcions`)
};

const cs_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předčasný přístup k novým funkcím`)
};

const da_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidlig adgang til nye funktioner`)
};

const de_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frühzeitiger Zugriff auf neue Funktionen`)
};

const et_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varajane juurdepääs uutele funktsioonidele`)
};

const es_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso anticipado a las nuevas funciones`)
};

const fr_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès anticipé aux nouvelles fonctionnalités`)
};

const hr_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rani pristup novim funkcionalnostima`)
};

const it_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso in anteprima alle nuove funzionalità`)
};

const lv_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrīna piekļuve jaunām funkcijām`)
};

const lt_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankstyva prieiga prie naujų funkcijų`)
};

const hu_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új funkciók kipróbálása elsőként`)
};

const nl_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vroege toegang tot nieuwe functies`)
};

const nb_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidlig tilgang til nye funksjoner`)
};

const pl_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczesny dostęp do nowych funkcji`)
};

const pt_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso antecipado a novos recursos`)
};

const ro_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acces timpuriu la noile caracteristici`)
};

const sk_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skorý prístup k novým funkciám`)
};

const sl_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgodnji dostop do novih funkcij`)
};

const fi_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varhainen pääsy uusiin ominaisuuksiin`)
};

const sv_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidig åtkomst till nya funktioner`)
};

const vi_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyền sử dụng sớm các tính năng mới`)
};

const tr_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni özelliklere erken erişim`)
};

const el_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρόωρη πρόσβαση σε νέες δυνατότητες`)
};

const bg_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранен достъп до нови функции`)
};

const ru_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранний доступ к новым функциям`)
};

const sr_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рани приступ новим функцијама`)
};

const uk_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранній доступ до нових функцій`)
};

const ka_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ახალ ფუნქციებზე ადრეული წვდომა`)
};

const hi_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए फीचर्स पर अर्ली एक्सेस `)
};

const th_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเข้าถึงคุณสมบัติใหม่ก่อนใคร`)
};

const ko_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로운 기능에 대한 얼리 액세스`)
};

const zh_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优先体验新功能`)
};

const zh_tw_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搶先體驗新功能`)
};

const ja_leo_feature_3 = /** @type {(inputs: Leo_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新機能への早期アクセス`)
};

/**
* | output |
* | --- |
* | "Early access to new features" |
*
* @param {Leo_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_feature_3 = /** @type {((inputs?: Leo_Feature_3Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Feature_3Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_feature_3(inputs)
	if (locale === "ms") return ms_leo_feature_3(inputs)
	if (locale === "ca") return ca_leo_feature_3(inputs)
	if (locale === "cs") return cs_leo_feature_3(inputs)
	if (locale === "da") return da_leo_feature_3(inputs)
	if (locale === "de") return de_leo_feature_3(inputs)
	if (locale === "et") return et_leo_feature_3(inputs)
	if (locale === "es") return es_leo_feature_3(inputs)
	if (locale === "fr") return fr_leo_feature_3(inputs)
	if (locale === "hr") return hr_leo_feature_3(inputs)
	if (locale === "it") return it_leo_feature_3(inputs)
	if (locale === "lv") return lv_leo_feature_3(inputs)
	if (locale === "lt") return lt_leo_feature_3(inputs)
	if (locale === "hu") return hu_leo_feature_3(inputs)
	if (locale === "nl") return nl_leo_feature_3(inputs)
	if (locale === "nb") return nb_leo_feature_3(inputs)
	if (locale === "pl") return pl_leo_feature_3(inputs)
	if (locale === "pt") return pt_leo_feature_3(inputs)
	if (locale === "ro") return ro_leo_feature_3(inputs)
	if (locale === "sk") return sk_leo_feature_3(inputs)
	if (locale === "sl") return sl_leo_feature_3(inputs)
	if (locale === "fi") return fi_leo_feature_3(inputs)
	if (locale === "sv") return sv_leo_feature_3(inputs)
	if (locale === "vi") return vi_leo_feature_3(inputs)
	if (locale === "tr") return tr_leo_feature_3(inputs)
	if (locale === "el") return el_leo_feature_3(inputs)
	if (locale === "bg") return bg_leo_feature_3(inputs)
	if (locale === "ru") return ru_leo_feature_3(inputs)
	if (locale === "sr") return sr_leo_feature_3(inputs)
	if (locale === "uk") return uk_leo_feature_3(inputs)
	if (locale === "ka") return ka_leo_feature_3(inputs)
	if (locale === "hi") return hi_leo_feature_3(inputs)
	if (locale === "th") return th_leo_feature_3(inputs)
	if (locale === "ko") return ko_leo_feature_3(inputs)
	if (locale === "zh") return zh_leo_feature_3(inputs)
	if (locale === "zh-tw") return zh_tw_leo_feature_3(inputs)
	if (locale === "ja") return ja_leo_feature_3(inputs)
	return en_leo_feature_3(inputs)
});